export class CruscottoStatistiche {
    totaleRichieste: number = 0;
    richiestePerStato: RichiestePerStato[] = [];
    totalePazienti: number = 0;
    totalePazientiMaschi: number = 0;
    totalePazientiFemmine: number = 0;
}

export class RichiestePerStato {
    codice: string = "";
    descrizione: string = "";
    numeroRichieste: number = 0;
}